<template>
  <div class="add-new-url-attribute">
    <div class="add-new-url-attribute__header">
      <div class="add-new-url-attribute__title">Create New URL Attribute</div>
    </div>

    <div class="add-new-url-attribute__content">
        <div class="add-new-url-attribute__input_block add-new-url-attribute__name">
          <div class="add-new-url-attribute__field_label">URL Attribute Name</div>
          <input v-model="name"
                 :class="['add-new-url-attribute__name_field', {'add-new-url-attribute__field_err': selectErrors.includes('name'), 'add-new-url-attribute__fields_disabled': disableButtons}]"
                 type="text" />
        </div>
        <div class="add-new-url-attribute__input_block">
          <div class="add-new-url-attribute__field_label">Is Active</div>
          <base-select class="add-new-url-attribute__select"
                       :class="{'add-new-url-attribute__field_err': selectErrors.includes('active'), 'add-new-url-attribute__fields_disabled': disableButtons}"
                       :options="selectOptions"
                       alignLeft
                       :isSortAsc="true"
                       :disabled="disableButtons"
                       showTopBorder
                       shiftLabelRight
                       v-model="isActive"
                       :selectStyle="{height: '60px!important'}"/>
        </div>
      </div>

    <div class="add-new-url-attribute__footer">
      <button class="add-new-url-attribute__button add-new-url-attribute__button_cancel"
              :class="{'add-new-url-attribute__fields_disabled': disableButtons}"
              @click="close(false)">cancel</button>
      <button class="add-new-url-attribute__button add-new-url-attribute__button_add"
              :class="{'add-new-url-attribute__fields_disabled': disableButtons}"
              @click="apply">save</button>
    </div>
  </div>
</template>

<script>
import { mapActions } from 'vuex'
import BaseModalMixins from '@/common/BaseModalMixins'

export default {
  name: 'AddNew',
  mixins: [BaseModalMixins],
  props: {
    selectOptions: {
      type: Array,
      required: true
    }
  },
  data () {
    return {
      disableButtons: false,
      name: '',
      isActive: 1,
      selectErrors: []
    }
  },
  watch: {
    name (value) {
      this.name = value.trim().replace(/ +/g, '-').replace(/_+/g, '-')
    }
  },
  methods: {
    ...mapActions('urlAttributes', ['createNewUrlAttributes']),
    close (isNeedUpdate = true) {
      this.$emit('close', isNeedUpdate)
    },
    async apply () {
      const selectErrors = []
      const { name, isActive } = this

      if (!name || !name.length) {
        selectErrors.push('name')
      }
      if (![0, 1].includes(isActive)) {
        selectErrors.push('active')
      }

      this.selectErrors = selectErrors
      if (selectErrors.length) {
        return
      }

      this.disableButtons = true
      const isCreated = await this.createNewUrlAttributes({ name, is_active: isActive, client_id: this.clientId })

      if (isCreated) {
        this.close()
      } else {
        this.selectErrors.push('name')
        this.disableButtons = false
      }
    }
  }
}
</script>

<style lang="scss" scoped>
  .add-new-url-attribute {
    padding: 40px;

    &__title {
      padding-bottom: 30px;
      text-align: center;
      font-size: 24px;
      line-height: 32px;
      color: $rfx-dark-march;
      font-weight: bold;
    }

    &__content {
      display: flex;

      &_block {
        flex: 1;

        &:first-child {
          padding-right: 15px;
        }

        &:last-child {
          padding-left: 15px;
        }
      }
    }

    &__input_block {
      flex: 1;

      &:first-child {
        padding-right: 15px;
      }

      &:last-child {
        padding-left: 15px;
      }
    }

    &__field_label {
      font-size: 14px;
      margin-bottom: 8px;
      color: $rfx-dark-march;
      font-weight: bold;
    }

    &__field {
      &_err {
        border: 1px solid $rfx-light-red !important;
      }
    }

    &__fields_disabled {
      pointer-events: none;
      opacity: .5;
    }

    &__name {
      display: flex;
      width: 100%;
      flex-direction: column;
      margin-bottom: 24px;

      &_field {
        height: 58px;
        border: 1px solid #e7e9eb;
        padding: 0 15px;
        font-size: 14px;
        border-radius: 4px;
        color: $rfx-dark-march;
      }
    }

    &__footer {
      margin-top: 40px;
      display: flex;
      align-items: center;
      justify-content: flex-end;
    }

    &__button {
      min-width: 100px;
      padding: 0 25px;
      height: 40px;
      font-size: 10px;
      font-weight: 900;
      cursor: pointer;
      text-transform: uppercase;
      border-radius: 8px;
      outline: none;
      border: none;

      &_cancel {
        color: $rfx-dark-march;
        margin-right: 15px;
        background-color: transparent;
        font-weight: 900;
      }

      &_add {
        color: #fff;
        background-color: $rfx-dark-march;
        margin-left: 15px;
      }
    }
  }
</style>
